import React, { ReactElement } from "react";

import _ from "lodash";
import { ConnectedProps, connect } from "react-redux";
import { AnyAction } from "redux";
import { ThunkDispatch } from "redux-thunk";

import { RootState } from "App/Store";

import * as constants from "Common/EVaultAppConstants";

import FilterBar from "Components/SearchBar/FilterBar";

import { QueryStringSearchKey } from "../Constants";
import { initialBatchOperationsSearchBarParams, resetSearch, updateSearchBarParams } from "./BatchOperationsSlice";
import { batchOperationsSearchParams } from "./BatchOperationsSlice";
import { executeSearch } from "./batchOperationsService";

const mapStateToProps = (state: RootState) => ({
  searchBarParams: state.batchOperations.searchBarParams,
});

const connector = connect(mapStateToProps);

type TypesFromRedux = ConnectedProps<typeof connector>;

const searchCriteria = [
  ...constants.baseSearchCriteria,
  {
    name: "searchKey",
    options: [
      {
        apiParamValue: QueryStringSearchKey.BatchId,
        description: "Batch Id",
      },
    ],
    type: 0,
  },
];

export function BatchOperationsFilterBar(props: TypesFromRedux): ReactElement {
  const { searchBarParams, dispatch } = props;

  function handleReset() {
    dispatch(resetSearch());
  }

  function handleSubmit() {
    (dispatch as ThunkDispatch<any, undefined, AnyAction>)(executeSearch());
  }

  function handleCriteriaChange(value: batchOperationsSearchParams) {
    dispatch(updateSearchBarParams(value));
  }

  const displayResetButton = !_.isEqual(initialBatchOperationsSearchBarParams, searchBarParams);

  return (
    <FilterBar
      displayResetButton={displayResetButton}
      onCriteriaChange={handleCriteriaChange}
      onReset={handleReset}
      onSubmit={handleSubmit}
      searchCriterias={searchCriteria}
      searchParams={searchBarParams}
    />
  );
}

export default connector(BatchOperationsFilterBar);
